import React, { Component } from 'react';
import { Col, FormGroup, Label, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { addCompanyChange } from '../actions/Companies';
import Toggle from './Toggle';

const dropdownOptions = [{ label: 'Agency', value: 'agency' }];

class AddCompanyFormForProposals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectType: dropdownOptions[0],
      name: props.comingFrom === 'edit' ? props.editData.name : props.name,
      status: props.comingFrom === 'edit' ? props.editData.enabled : props.status,
      permissions: {
        emailNotifications:
          props.comingFrom === 'edit' ? props.editPermissions.emailNotifications : false,
        showCallRecording:
          props.comingFrom === 'edit' ? props.editPermissions.showCallRecording : false,
      },
    };
    this.onEnabledChange = this.onEnabledChange.bind(this);
  }

  componentDidMount() {
    this.props.addCompanyChange({
      name: 'companyType',
      value: this.state.selectType.value,
    });
  }

  onAddedCompanyChange = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyChange({ name, value });
  };

  onEnabledChange(value) {
    this.props.addCompanyChange({ name: 'enabled', value: !value });
    this.setState({ status: !value });
  }

  render() {
    const { getAgency } = this.props;
    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={4}>
            Company Name
          </Label>
          <Col sm={8}>
            <Input
              required
              type="text"
              name="name"
              value={this.state.name}
              onChange={this.onAddedCompanyChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4}>Type</Label>
          <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <Input value={dropdownOptions[0].value} readOnly />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="enabled" sm={4}>
            Status
          </Label>
          <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <Toggle
              containerStyle={{ width: '90px' }}
              trackStyle={{ width: '90px' }}
              inactiveLabel="Disabled"
              activeLabel="Enabled"
              value={this.state.status}
              thumbAnimateRange={[1, 70]}
              onToggle={this.onEnabledChange}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label sm={4}>Logo</Label>
          <Col sm={8}>
            <Button
              style={{ background: 'inherit', border: 'none', color: '#29a4ff' }}
              onClick={() => this.props.showDownloadDocsModal()}
            >
              <FontAwesomeIcon
                icon="plus"
                size="sm"
                color="#29a4ff"
                style={{ marginRight: '1rem' }}
              />
              {getAgency() && getAgency().logo && getAgency().logo !== ''
                ? 'Update Logo'
                : 'Add Logo'}
            </Button>
          </Col>
        </FormGroup>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    name: state.UIState.companies.addedCompany.name,
    status: state.UIState.companies.addedCompany.enabled,
    editData: state.UIState.companies.editCompanyData,
    editPermissions: state.UIState.companies.editCompanyData.permissions || '',
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCompanyChange: companyData => dispatch(addCompanyChange(companyData)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCompanyFormForProposals);
